
<template>
  <b-modal
    v-if="group"
    ref="modal"
    id="agGroupModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="saveButton_click">
    <template slot="modal-header">
      <h4 v-if="isEditing" class="agModal-title">Edit Group</h4>
      <h4 v-else class="agModal-title">New Group</h4>
    </template>
    <b-input-group size="md" prepend="Name">
      <b-input type="text" v-model="group.name" autocomplete="false"></b-input>
    </b-input-group>
     <b-input-group size="md" prepend="Description">
      <b-input type="text" v-model="group.description" autocomplete="false"></b-input>
    </b-input-group>
    <hr>
     <div class="agInputGroup">
        <label>Users:</label>
        <b-table 
          id="agGroupModal-usersTable"
          :items="userItems"
          borderless
          outlined
          small>   
          <template #head(enabled)>
              <input type="checkbox" v-model="usersEnableAll" @click="usersEnableAll_click"/>
            </template>
          <template #cell(enabled)="data">
            <input type="checkbox" v-model="data.item.enabled" />
          </template>  
       </b-table>
      </div>
    <div v-if="modalMessage">
      <hr>
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button class="agModal-buttonRight" variant="primary" @click="saveButton_click" :disabled="isLoading">Save</b-button>
    </template>
  </b-modal>
</template>






<script>

// components


// modules
import Util from "src/util/util";


export default {
    name: "ag-group-modal",
    components: {

    },
    props:{
        group: Object,
        users: Array
    },
    data(){
      return {
        isLoading: false,
        modalMessage: "",
        modalMessageClass: "",
        errorField: "",
        usersEnableAll: false,
        userItems: [],
      };
    },
    computed: {
      
      isEditing() {
        if(this.group._id)
          return true;
        return false;
      },

      groups() {
        return this.$store.state.userStore.groups;
      },
    },
    watch: {
      
    },

    created() {

    },

    mounted() {
    },

    methods: {

        // UI Events

        async saveButton_click() {
          if(!this.validate()) {
            return;
          }

          // build users array
          this.group.users = [];
          for(var i = 0; i < this.userItems.length; i++) {
              var userItem = this.userItems[i];
              if(userItem.enabled) {
                var user = this.users.find(a => a.username == userItem.username);
                this.group.users.push(user);
              }
          }

          // save 
          this.isLoading = true;
          if(this.group._id)
            var func = "updateGroup";
          else
            var func = "insertGroup";
          
          var result = await this.$store.dispatch("userStore/" + func, {group: this.group});
          this.isLoading = false;
          if(result.data.success) {
              this.hide();
              this.$emit("savedGroup");
          } 
          else {
            this.modalMessage = result.data.error;
            this.modalMessageClass = "agModal-errorMessage";
          }
        },

        usersEnableAll_click(e)
        {
            var enabled = e.currentTarget.checked;
            for(var i = 0; i < this.userItems.length; i++)
            {
                var user = this.userItems[i];
                user.enabled = enabled;
            }
        },


        // emitted Events

        // other

        show() {
          setTimeout(() => {
            this.reset();
            this.$refs.modal.show();
          }, 250);        
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          this.modalMessage = "";
          this.modalMessageClass = "";
          this.errorField = "";
          this.usersEnableAll = false;
          this.setUserItems();
        },

        hasError(field) {
            if (field == this.errorField) {
                return false; // false = error
            }
            return null;
        },

        validate()
        {
          this.modalMessage = "";
          this.modalMessageClass = "";
          this.errorField = "";

          if(!this.group.name || this.group.name.length == 0) {
            this.modalMessage = "Name is required";
            this.modalMessageClass = "agModal-errorMessage";
            this.errorField = "name";
            return false;
          }
          var existing = this.groups.find(a => a.name == this.group.name);
          if(existing && existing._id != this.group._id) {
            this.modalMessage = "A group named \"" + this.group.name + "\" already exists";
            this.modalMessageClass = "agModal-errorMessage";
            this.errorField = "name";
            return false;
          }

          // make sure there's at least one user
          var hasUser = false;
          for(var i = 0; i < this.userItems.length; i++) {
              var userItem = this.userItems[i];
              if(userItem.enabled) {
                hasUser = true;
                break;
              }
          }
          if(!hasUser) {
            this.modalMessage = "At least one user must be selected";
            this.modalMessageClass = "agModal-errorMessage";
            this.errorField = "users";
            return false;
          }

          return true;
        },

        setUserItems() {
          console.log(this.group);
            this.userItems = [];
            for(var i = 0; i < this.users.length; i++) {
                var user = this.users[i];
                var existing = this.group.users.find((a) => a.username == user.username);
                if(existing)
                    this.userItems.push({enabled: true, username: user.username, name: user.name});
                else
                    this.userItems.push({enabled: false, username: user.username, name: user.name});
            }
        },
    }
}

</script>






<style scoped lang="css">


#agGroupModal-usersTable
{
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 155px);
    height: 175px;
    overflow: auto;
    border-collapse: collapse
}

</style>



// WEBPACK FOOTER //
// src/components/user/GroupModal.vue